import Dialog from '$tablet-app/src/app/components/Dialog';
import { DialogProps } from '$tablet-app/src/app/components/Dialog/Dialog';
import DialogHeader from '$tablet-app/src/app/components/Dialog/DialogHeader';
import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import styled from 'styled-components/native';
import { DriveVideo } from '../DriveVideo';

interface Props extends DialogProps {
  title?: string;

  source: { drive_id: string } | { uri: string };
}

export const VideoDialog = ({ source, title, ...props }: Props) => {
  return (
    <StyledDialog size="xl" {...props}>
      <DialogHeader
        center={
          title ? (
            <Text variant="h2" weight="bold">
              {title}
            </Text>
          ) : null
        }
        right={
          <Button
            variant="secondary"
            icon="times"
            size="xlarge"
            onPress={props.onClose}
          />
        }
      />
      <Body>
        <DriveVideo source={source} />
      </Body>
    </StyledDialog>
  );
};

const StyledDialog = styled(Dialog)`
  padding: 16px;
  flex: 1;
`;

const Body = styled.View`
  flex: 1;
  flex-direction: row;
  width: 100%;
`;
